'use strict';

const ProjectRepository = require('common/domain/repository/project');
const ProjectStatusRepository = require('common/domain/repository/project-status');
const ProjectAPI = require('common/infra/api/project');

class Service {
    constructor(group, project) {
        this._group = group;
        this._project = project;
    }

    delete() {
        const group = this._group;
        const projectID = this._project.id;

        return ProjectAPI.delete(projectID).then(() => {
            ProjectRepository.remove(projectID);
            ProjectStatusRepository.find(group).deleteByProjectID(projectID);
        });
    }
}

module.exports = Service;



// WEBPACK FOOTER //
// ./common/app/service/project/delete.js